export function nullIfEmpty(arg: any) {
	if (!arg) {
		return null;
	}

	return arg;
}
